(() => {
  /* 1 – Pick the scroll container
     --------------------------------------------- */
  const rootEl = document.getElementById('MainContent');
  const scroller =
    rootEl && rootEl.scrollHeight > rootEl.clientHeight ? rootEl : null;   // null → viewport
 

  /* 2 – Find every menu link … */
  const links = [...document.querySelectorAll('.header__menu-item[href^="#"]')];
  if (!links.length) {
    console.warn('[scroll-menu] No .header__menu-item anchors found');
    return;
  }

  /* …and the element that owns its id */
  const targets = links 
    .map(a => document.getElementById(a.getAttribute('href').slice(1)))
    .filter(Boolean);



  if (!targets.length) {
    console.warn('[scroll-menu] None of those ids exist in the DOM');
    return;
  }

  /* Map id → link element, once */
  const linkMap = Object.fromEntries(
    links.map(a => [a.getAttribute('href').slice(1), a])
  );

  /* 3 – IntersectionObserver
     --------------------------------------------- */
  const observer = new IntersectionObserver(handle, {
    root: scroller,               // null = viewport
    rootMargin: '-50% 0px -50% 0px',  // section is “active” when its centre crosses the viewport centre
    threshold: 0
  });

  targets.forEach(el => observer.observe(el));


  document.addEventListener("DOMContentLoaded", () => {
  const hash = window.location.hash;
  if (hash && hash.startsWith("#")) {
    const el = document.querySelector(hash);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth" });
      }, 300); // Delay to ensure layout is stable
    }
  }
});

  function handle(entries) {
    /* Who’s most visible right now? */
    const visibles = entries
      .filter(e => e.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

    if (!visibles.length) return;

    const currentId = visibles[0].target.id;

    /* Toggle .active */
    links.forEach(a =>
      a.classList.toggle('active', a.getAttribute('href').slice(1) === currentId)
    );

   
  }
})();


const swiper = new Swiper('.logocswiper', {
  slidesPerView: 5,
  freeMode: true,
  loop: true,
 
  speed: 4000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false
  },
   breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2
     
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 2
    
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 5
     
    }
  },
  allowTouchMove: false,
  spaceBetween: 40,
  on: {
    
    init(swiper) {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const slideWidth = isMobile ? 900 : 240;   
      
      swiper.slides.forEach(slide => {
        slide.style.width = `${slideWidth}px`;
      });
    }
  }
});


$('a[href^="#"]').on('click', function (e) {
  var target = $(this.getAttribute('href'));
  if (target.length) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: target.offset().top
    }, 600);
  }
});






(() => {
  const isMobileOrIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || innerWidth < 768;
  const canvas = document.createElement('canvas');
  canvas.className = 'connecting-dots';
  canvas.style.position = 'fixed';
  canvas.style.top = 0;
  canvas.style.left = 0;
  canvas.style.zIndex = -1;
  canvas.style.pointerEvents = 'none';
  document.body.appendChild(canvas);

  const DENSITY_PER_MP = isMobileOrIOS ? 30 : 120;
  const DOT_DISTANCE = isMobileOrIOS ? 60 : 85;
  const DOT_DISTANCE_HOVER = isMobileOrIOS ? 100 : 130;
  const DOT_MOUSE_RADIUS = isMobileOrIOS ? 60 : 100;
  const DOT_RADIUS_DESKTOP = isMobileOrIOS ? [0.3, 1.8] : [1, 8.2];
  const LINE_WIDTH_BASE = isMobileOrIOS ? 1.0 : 2.5;
  const LINE_WIDTH_HOVER = isMobileOrIOS ? 0.5 : 1.2;
  const LINE_ALPHA_BASE = 0.3;
  const DOT_ALPHA_BASE = 0.4;
  const DOT_ALPHA_HOVER = 1;

  const ctx = canvas.getContext('2d');
  const dots = { array: [] };
  const mouse = { x: -9999, y: -9999 };
  let dpr = isMobileOrIOS ? 1 : Math.min(window.devicePixelRatio || 1, 2);

  function resize() {
    const w = document.documentElement.clientWidth;
    const h = Math.max(document.body.scrollHeight, window.innerHeight);
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);
    rebuild(w, h);
  }

  function rebuild(w, h) {
    const total = Math.round((w * h) / 1e6 * DENSITY_PER_MP);
    dots.array = Array.from({ length: total }, () => new Dot(w, h));
  }

  function Dot(w, h) {
    const [mn, mx] = DOT_RADIUS_DESKTOP;
    Object.assign(this, {
      x: Math.random() * w,
      y: Math.random() * h,
      vx: (Math.random() - 0.5) * 0.5,
      vy: (Math.random() - 0.5) * 0.5,
      r: mn + Math.random() * (mx - mn)
    });
  }

  Dot.prototype.move = function (w, h) {
    if (this.x < 0 || this.x > w) this.vx *= -1;
    if (this.y < 0 || this.y > h) this.vy *= -1;
    this.x += this.vx;
    this.y += this.vy;
  };

  Dot.prototype.draw = function (highlight) {
    ctx.globalAlpha = highlight ? DOT_ALPHA_HOVER : DOT_ALPHA_BASE;
    ctx.beginPath();
    ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    ctx.fill();
  };

  function skipIdle(i, j) {
    return ((i * 73856093 ^ j * 19349663) & 15) > 4;
  }

  let lastRenderTime = 0;
  const TARGET_FPS = isMobileOrIOS ? 15 : 60;
  const FRAME_INTERVAL = 1000 / TARGET_FPS;

  function loop(timestamp) {
    if (timestamp - lastRenderTime < FRAME_INTERVAL) {
      requestAnimationFrame(loop);
      return;
    }
    lastRenderTime = timestamp;

    const w = canvas.width / dpr;
    const h = canvas.height / dpr;

    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = ctx.strokeStyle = '#CFCFCF';

    dots.array.forEach(d => {
      d.move(w, h);
      const highlight = Math.hypot(d.x - mouse.x, d.y - mouse.y) < DOT_MOUSE_RADIUS;
      d.draw(highlight);
    });

    for (let i = 0; i < dots.array.length; i++) {
      const a = dots.array[i];
      for (let j = i + 1; j < dots.array.length; j++) {
        const b = dots.array[j];
        const dx = a.x - b.x;
        const dy = a.y - b.y;
        const distSq = dx * dx + dy * dy;
        const highlight = Math.hypot(a.x - mouse.x, a.y - mouse.y) < DOT_MOUSE_RADIUS;
        const max = highlight ? DOT_DISTANCE_HOVER : DOT_DISTANCE;
        if (distSq > max * max) continue;
        if (!highlight && skipIdle(i, j)) continue;

        ctx.lineWidth = (highlight ? LINE_WIDTH_HOVER : LINE_WIDTH_BASE) / dpr;
        ctx.globalAlpha = highlight ? 1 : LINE_ALPHA_BASE;
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }
    }

    requestAnimationFrame(loop);
  }

  window.addEventListener('resize', resize);
window.addEventListener('mousemove', e => {
  const rect = canvas.getBoundingClientRect();
  mouse.x = e.clientX - rect.left;
  mouse.y = e.clientY - rect.top;
});

  resize();
  requestAnimationFrame(loop);
})();